import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Image } from "react-bootstrap";
import { usePermission } from "../../hooks/usePermission";
import { ATTENDANCE_QR_CODE_GET } from "../../routes/routes";
import { FullPageLoader } from "../../components/common/Loader";
import { toast } from "react-toastify";

const Settings = () => {
  const { hasPermission } = usePermission();
  const [qrUrl, setQrUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (!qrUrl) return;
    try {
      setDownloading(true);
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "Attendance-QR-Code.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch {
      toast.error("Failed to download QR Code. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    if (!hasPermission("settings-list")) {
      setLoading(false);
      return;
    }
    axios
      .get(ATTENDANCE_QR_CODE_GET)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setQrUrl(res.data.data?.url || "");
        }
      })
      .catch(() => {
        setError("Unable to load Attendance QR Code.");
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasPermission("settings-list")) {
    return (
      <div className="content-wrapper">
        <div className="container-fluid p-0 mt-0 mb-2">
          <div className="col-lg-12">
            <h5 className="page-title text-danger">Access Denied</h5>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Attendance QR Code</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/"}>Dashboard</Link>
                    </div>
                  </div>
                </li>

                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Attendance QR Code</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-4">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        {!loading && error ? <p className="text-danger">{error}</p> : null}
                        {!loading && !error && qrUrl ? (
                          <Image width={240} height={240} src={qrUrl} alt="Attendance QR Code" />
                        ) : null}
                        {!loading && !error && !qrUrl ? (
                          <p className="text-muted">Attendance QR Code not available.</p>
                        ) : null}
                      </div>
                    </div>

                    {qrUrl ? (
                      <div className="demo-inline-spacing d-flex justify-content-end">
                        <button
                          type="button"
                          disabled={downloading}
                          className="btn btn-success isubmit_button"
                          onClick={handleDownload}
                        >
                          {downloading ? "Downloading..." : "Download"}
                        </button>
                      </div>
                    ) : null}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
